var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"contenedor"},[(_vm.loadingOptionsList || _vm.loading)?_c('LoadingSpinner'):_vm._e(),(!_vm.loadingOptionsList && !_vm.loading)?_c('div',{staticClass:"card mt-3 mb-5"},[_c('div',{staticClass:"px-4 pb-2 pt-4"},[_c('div',[_c('AgencyContractDetail',{attrs:{"model":_vm.model}})],1)])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }